import { IUCServer } from "~/web-shared-components/interfaces/interfaces";
import { TLogLevel } from "~/web-shared-components/interfaces/types";

export enum LeftColumnE {
	CONTACTS = "contacts",
	LINE_SETTINGS = "lineSettings",
	APP_SETTINGS = "appSettings",
	NOTIFICATION_SETTINGS = "notificationSettings"
}
export interface IJsonConfig {
	logLevel?: TLogLevel;
	oem?: string;
	companyCopyright?: string;
	estosPrivacyURL?: string;
}
